import { withStyles } from "@material-ui/core";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const styles = (theme) => ({
  receivingHours: {
    fontSize: theme.textFontSize,
    fontWeight: "bold",
    paddingBottom: 10,
    paddingTop: 8,
    textTransform : "uppercase"
  },
  closedDay: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    paddingBottom: 20,
  },
  infoOutlinedIconStyle: {
    paddingLeft: 7,
  },
});
const InfoHeader = ({ classes, title }) => {
  return (
    <>
      <div className={classes.receivingHours}> {title} </div>
      <div className={classes.closedDay}>
        <InfoOutlinedIcon />
        <span className={classes.infoOutlinedIconStyle}>
          00:00 signifies marked closed
        </span>
      </div>
    </>
  );
};

export default withStyles(styles)(InfoHeader);